
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "bs-label"
})
export default class BsLabelComponent extends Vue {
 
}
